import { useState } from "react";
import { Filing } from "../../../models/Filing";
import { useFiling } from "../../../contexts/FilingContext";
import { Button } from "../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../design/dialog";
import { Input } from "../../../design/input";
import { Field, Fieldset, FieldGroup, Label } from "../../../design/fieldset";
import { FilingService } from "../../../services/FilingService";

interface Props {
  filing: Filing;
}

const DownloadFilingButton: React.FC<Props> = ({ filing }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  if (!filing.blobName) return null;

  const handleDownloadButtonPressed = async () => {
    setIsDownloading(true);
    try {
      const downloadUrl = await FilingService.getDownloadURL(filing._id);
      window.open(downloadUrl, "_blank");
    } catch (error) {
      console.error("Error downloading filing:", error);
    }
    setIsDownloading(false);
  };
  return (
    <Button disabled={isDownloading} onClick={handleDownloadButtonPressed}>
      {isDownloading ? "Downloading..." : "Download Filing"}
    </Button>
  );
};

export default DownloadFilingButton;
